var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { autocomplete: "off" },
      model: {
        value: _vm.formValid,
        callback: function($$v) {
          _vm.formValid = $$v
        },
        expression: "formValid"
      }
    },
    [
      _c(
        "v-container",
        { staticClass: "pa-0" },
        [
          _c(
            "h1",
            {
              staticClass: "wizard-header-text",
              staticStyle: { display: "flex" }
            },
            [
              !_vm.isMobile
                ? _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")])
                : _vm._e(),
              _c("div", { staticClass: "wizard-header-info" }, [
                _c("span", [
                  _vm._v(
                    "Cenu poistenia vypočítame na základe vami zadaných údajov"
                  )
                ])
              ])
            ]
          ),
          _vm.debug
            ? _c("debug-control", {
                attrs: {
                  value: [
                    "validationObjectResult",
                    "formValid",
                    "somethingGetDirty",
                    "currentControl",
                    "somethingIsLoading"
                  ],
                  parent: this
                },
                on: { click: _vm.log }
              })
            : _vm._e(),
          _vm._l(_vm.predmety, function(item, index) {
            return _c(
              "v-row",
              {
                key: index,
                staticClass: "card predmet-form",
                class: { "mt-24px": !_vm.isMobile },
                attrs: { "no-gutters": "" }
              },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "v-row",
                      {
                        style: _vm.isMobile ? { marginBottom: "10px" } : null,
                        attrs: { "no-gutters": "" }
                      },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _vm.predmety.length > 1
                              ? [
                                  _c("h2", [
                                    _vm._v(_vm._s(item.typ_predmetu_sufix))
                                  ])
                                ]
                              : [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        item.predmet
                                          ? item.predmet
                                          : "Údaje o predmete"
                                      )
                                    )
                                  ])
                                ]
                          ],
                          2
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "4" } },
                          [
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.predmety.length > 1,
                                    expression: "predmety.length > 1"
                                  }
                                ],
                                staticClass:
                                  "pa-0 predmet-expand btn-secondary right",
                                attrs: { disabled: item.active },
                                on: {
                                  click: function($event) {
                                    return _vm.selectPredmet(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { class: { "rotate-180": item.active } },
                                  [_vm._v("mdi-chevron-down")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.dbPredmety.length > 1 ||
                                      (_vm.predmety.length > 1 &&
                                        item.loadedFromDb == false),
                                    expression:
                                      "dbPredmety.length > 1 || (predmety.length > 1 && item.loadedFromDb == false)"
                                  }
                                ],
                                staticClass:
                                  "pa-0 mr-2 predmet-expand btn-secondary right",
                                on: {
                                  click: function($event) {
                                    return _vm.deletePredmet(item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("$trash")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-expand-transition",
                  [
                    _c("predmet-form", {
                      key: "predmetForm" + item.cislo_predmetu,
                      ref: "predmetForm" + item.cislo_predmetu,
                      refInFor: true,
                      attrs: {
                        isMobile: _vm.isMobile,
                        cisloPredmetu: item.cislo_predmetu,
                        newId: _vm.pripad.newId,
                        reloaded: item.active,
                        active: item.active
                      },
                      on: {
                        vinChecking: function() {
                          return _vm.setValid(
                            false,
                            "checkVin",
                            "",
                            false,
                            false
                          )
                        },
                        vinChecked: function() {
                          return _vm.setValid(
                            true,
                            "checkVin",
                            "",
                            false,
                            false
                          )
                        },
                        resetCheckPredmet: function() {
                          return _vm.setValid(
                            true,
                            "checkPredmet",
                            "",
                            false,
                            false
                          )
                        },
                        changeSufixPredmetu: function(val) {
                          return (item.typ_predmetu_sufix = val)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }